import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import type { ChannelSimpleChannelableTypeEnum } from './../constants.js';
import { Transform } from 'class-transformer';
import type { Constructor } from '@whispli/types';

export class __ChannelSimple extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly name!: string;
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly locale!: string;
  /**
   * @deprecated For backwards-compatibility only. Use channelableType
   */
  @Type(() => String)
  @Expose({groups:["server"]})
  private channelable_type!: ChannelSimpleChannelableTypeEnum;

  @Expose({groups: ['client']})
  public get channelableType() {
    return this.channelable_type
  }

  public set channelableType(value) {
    this.channelable_type = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use channelableId
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private channelable_id!: string;

  @Expose({groups: ['client']})
  public get channelableId() {
    return this.channelable_id
  }

  public set channelableId(value) {
    this.channelable_id = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use channelTypeId
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private channel_type_id!: string;

  @Expose({groups: ['client']})
  public get channelTypeId() {
    return this.channel_type_id
  }

  public set channelTypeId(value) {
    this.channel_type_id = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use channelStatusId
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private channel_status_id!: string;

  @Expose({groups: ['client']})
  public get channelStatusId() {
    return this.channel_status_id
  }

  public set channelStatusId(value) {
    this.channel_status_id = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use isDisclosureChannel
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private is_disclosure_channel!: boolean;

  @Expose({groups: ['client']})
  public get isDisclosureChannel() {
    return this.is_disclosure_channel
  }

  public set isDisclosureChannel(value) {
    this.is_disclosure_channel = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private created_at!: string;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private updated_at!: string;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use liveAt
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private live_at!: string;

  @Expose({groups: ['client']})
  public get liveAt() {
    return this.live_at
  }

  public set liveAt(value) {
    this.live_at = value
  }
}
export type ChannelSimple = Omit<__ChannelSimple, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'channelable_type' | 'channelable_id' | 'channel_type_id' | 'channel_status_id' | 'is_disclosure_channel' | 'created_at' | 'updated_at' | 'live_at'>
export const ChannelSimple = __ChannelSimple as any as Constructor<ChannelSimple>
